// extracted by mini-css-extract-plugin
export default {"l_ExtensionContainer_main":"ExtensionContainer_l_ExtensionContainer_main__h9g7u","extension":"ExtensionContainer_extension__NN43S"};